export default __webpack_public_path__ + "static/authentication-page-eaa90da0f730bd9972b1fc1705ecd780.png";